import { connect } from 'react-redux';
import { pick, isNil, has, min, size, mapValues } from 'lodash';
import { getConnectionTypes } from '../../../reducers/selectors';
import FlowPreview from './FlowPreview';
import { getResourceEntity } from 'js/lib/PipelineUtils';

const mapStateToProps = (state, ownProps) => {
  const {
    entities,
    pipelines: { branches, edges, parentRelationships, treeHeights, isPreview },
  } = state;
  const { nodeKey, excludeFlowControlNode } = ownProps;
  const { flowNodes } = entities;
  let showFlow = !!(nodeKey && !isPreview);

  if (!nodeKey) {
    return {
      pipelineItems: null,
      pipelineEdges: null,
      branches: null,
      connectionTypes: getConnectionTypes(state),
      showFlow,
      excludeFlowControlNode,
    };
  }

  const branch =
    !isNil(nodeKey) && has(branches, nodeKey) ? branches[nodeKey] : { items: [], edges: [] };
  const pipelineItems = mapValues(pick(flowNodes, branch.items), (flowNode) =>
    getResourceEntity(flowNode, entities),
  );
  const pipelineEdges = pick(edges, branch.edges);
  let rootKey;

  for (rootKey = nodeKey; parentRelationships[rootKey]; rootKey = parentRelationships[rootKey]);

  const treeHeight = min([treeHeights[rootKey], size(pipelineItems)]);

  return {
    rootKey,
    pipelineItems,
    pipelineEdges,
    branches,
    treeHeight,
    connectionTypes: getConnectionTypes(state),
    showFlow,
    excludeFlowControlNode,
  };
};

export default connect(mapStateToProps, {})(FlowPreview);
